const getFirstNumberInString = (string) => {
    const reg = /^[^\d]*(\d+)/;

    if (string.match(reg) !== null) return string.match(reg)[1];
    else return false;
}

export default getFirstNumberInString;